import * as React from 'react'
import { AnimatePresence } from '@eversports/klimt-utilities/framer-motion'

import Header from '../../components/Header'
import Footer from '../../components/Footer'

import InvoiceHistory from './InvoiceHistory'

const InvoiceHistoryPage = () => {
  return (
    <>
      <Header />
      <AnimatePresence mode="wait">
        <InvoiceHistory />
      </AnimatePresence>
      <Footer />
    </>
  )
}

export default InvoiceHistoryPage
